import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SurveyComponent } from "app/admin/survey/survey.component";
import { ToastrService } from 'ngx-toastr';
import { GridOptions } from "ag-grid/main";
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AdminService, QuestionDto } from 'app/services/admin/AdminService';
import swal from 'sweetalert2';
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-new-survey-modal',
    templateUrl: './new-survey-modal.component.html',
    styleUrls: ['./new-survey-modal.component.scss']
})
export class NewSurveyModalComponent implements OnInit {
    oldText: string;
    @ViewChild('newsurvey', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: any;
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    choiceAction: string;

    languages: any[] = [];
    localizations: any[] = [];
    questionId: number;
    type: number = 3;
    action: string;
    currentLocalizationsChoices: any[] = [];

    choicesDictionary: { [shortCode: string]: any[] } = {};
    choices: any[] = [];

    currentLocalizationsChoicesHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    currentOrDefaultLanguage: string;
    currentOrDefaultLanguageShortCode: string;

    newChoice: boolean = false;
    editChoice: boolean = false;

    defaultShortCode: string = "en";
    previousShortCode: string;

    rowClassRules;

    choicesGroupById:any[] = [];
    allIds:any[] = [];
    deletedChoices: any[] = [];

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;

    testQuestion: boolean = false;
    isMandatory: boolean = false;
    loadingChoices: boolean = false

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    savingQuestion: boolean = false;
    constructor
        (
            private _AdminService: AdminService,
            private toastr: ToastrService,
            private router: Router,
            private _Globals: Globals
        )
    {
        this.overlayNoRowsTemplate = "<span>No rows to show</span>";
        this.rowClassRules = {
            "deleted": function (params) {
                var status = params.data.Status;
                return status == 2;
            }
        };
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.getLanguages();

        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;
        //this.gridOptions.getRowNodeId = function (data) {
        //    return data.id;
        //};

        this.currentLocalizationsChoicesHeaders = this.createHeaders();
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;
            
            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
              this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;

            for (var i = 0; i < this.languages.length; i++) {
                let shortCode = _data[i].ShortCode;
                this.choicesDictionary[shortCode] = [];
            }
            console.log('choicesDictionary', this.choicesDictionary);

            //set deafult language and shotcode
            this.currentOrDefaultLanguage = _data["0"].Name;
            this.currentOrDefaultLanguageShortCode = _data["0"].ShortCode;
        });
    }

    //getQuestion() {
        //this._getQuestion.getQuestion(this.questionId).subscribe((_data: any) => {
            //console.log('question', data.result);
            //this.localizations = data.result.Localizations;
            //this.choices = data.result.Choices;
            //this.setCurrentLocalizationsChoices(this.choices, this.defaultShortCode);

            //this.populateLocalizations();
        //})
    //}

    getQuestion() {
        this.loadingChoices = true;
        this._AdminService.getQuestion(this.questionId).subscribe((_data: any) => {

            console.log('response_getQuestion', _data);
            if (this._Globals.validationToken(_data.result.Result)) {
                let data = JSON.parse(_data.result.Data);

                console.log('question', data);
                this.localizations = data.Localizations;
                this.choices = data.Choices;
                this.setCurrentLocalizationsChoices(this.choices, this.defaultShortCode);

                this.populateLocalizations();

                this.testQuestion = data.IsTestQuestion;
                if (this.testQuestion) {
                    $('#surCheckboxTest').prop('checked', true);
                }

                this.isMandatory = data.IsMandatory;
                console.log("isMandatory",this.isMandatory);

                this.loadingChoices = false;
            }
        })
    }

    populateLocalizations() {
        //autopopulate dictionary
        for (var i = 0; i < this.localizations.length; i++) {
            this.setCurrentLocalizationsChoices(this.choices, this.languages[i].ShortCode);
        }
        console.log('autopopulate dictionary', this.choicesDictionary);
    }

    setCurrentLocalizationsChoices(choices: any[], languageShortCode:string): void {
        this.currentLocalizationsChoices = [];

        if (this.choicesDictionary[languageShortCode].length == 0 && this.deletedChoices.length == 0) {
            for (var i = 0; i < choices.length; i++) {
                let localizations = choices[i].Localizations;
                let id = choices[i].Id;
                let status = choices[i].Status;

                for (var j = 0; j < localizations.length; j++) {
                    if (localizations[j].LanguageShortCode == languageShortCode) {
                        localizations[j].Id = id;
                        localizations[j].Status = status;
                        this.choicesDictionary[languageShortCode].push(localizations[j]);
                    }
                }
            }
            this.sizeToFit();
        }

        //if (languageShortCode != this.defaultShortCode) {

        if (this.choicesDictionary[this.previousShortCode].length != this.choicesDictionary[languageShortCode].length) {
            //adding missing translations
            let totalToAdd = this.choicesDictionary[this.previousShortCode].length - this.choicesDictionary[languageShortCode].length;

            for (var i = 0; i < totalToAdd; i++) {
                let language = this.getLanguageByShortcode(languageShortCode);
                let newChoice = {
                    "LanguageName": language,
                    "LanguageShortCode": languageShortCode,
                    "Text": 'Missing translation',
                    "Id": 0
                };
                this.choicesDictionary[languageShortCode].push(newChoice);
            }
        }
        //}
        let currentLanguageVal = $('#surveyLanguages').val();
        this.currentLocalizationsChoices = this.choicesDictionary[currentLanguageVal];
        this.previousShortCode = languageShortCode;
        console.log('currentChoices', this.currentLocalizationsChoices);
        console.log('choicesDictionary', this.choicesDictionary);
    }

    getLanguageByShortcode(shortcode:string): string {
        for (var i = 0; i < this.languages.length; i++){
            if (this.languages[i].ShortCode == shortcode) {
                return this.languages[i].Name;
            }
        }
    }

    getShortcodeByIndex(idx: number): string {
        return this.languages[idx].ShortCode;
            
    }

    show(text: string, parent: any, action, questionId, boolGetAllQuestions: boolean): void {
       $('#surveyTextarea').val(text);
        this.text = text;
        this.parent = parent;

        this._Globals.boolGetAllQuestions = boolGetAllQuestions;

        this.questionId = questionId;
        this.action = action;
        this.previousShortCode = this.defaultShortCode;
        switch (action) {
            case "edit":
                this.actionEdit = true;
                this.currentOrDefaultLanguage = 'English';
                this.currentOrDefaultLanguageShortCode = 'en';
                this.getQuestion();
                break;
            case "create":
                this.actionCreate = true;
                this.currentOrDefaultLanguage = 'English';
                this.currentOrDefaultLanguageShortCode = 'en';
                break;
        }
        this.modal.show();
    }

    onShown(): void {
    }

    close(): void {
        this.modal.hide();
        this.resetActions();
        this.clearArrays();
        this.testQuestion = false;
        this.isMandatory = false;
    }

    clearArrays() {
        this.localizations = [];
        this.deletedChoices = [];
        this.allIds = [];
        this.choices = [];
        this.currentLocalizationsChoices = [];
    }

    resetActions() {
        this.actionCreate = false;
        this.actionEdit = false;
        $('#surveyLanguages').prop('selectedIndex', 0);
        for (var i = 0; i < this.localizations.length; i++) {
            this.choicesDictionary[this.localizations[i].LanguageShortCode] = [];
        }
        console.log('choicesDictionary', this.choicesDictionary);
    }

    saveQuestion() {
        console.log('saveQuestion');
        let data = $('#surveyTextarea').val();

        if (data == '') {
            if (this.localizations.length > 0) {
                if (this.localizations["0"].Text == '') {
                    this.toastr.warning('Field empty', 'ELI');
                    return;
                }
            } else {
                this.toastr.warning('Please complete the question body.','ELI');
                return;
            }
            
        }

        

        let questionId = 0;
        if (!this.actionCreate) {
            questionId = this.questionId;
        }

        let testQuestion = 0;
        if (this.testQuestion) {
            testQuestion = 1;
        }

        let choices = this.generateJson();

        if (choices.length == 0 || this.choicesDictionary['en'].length == 0) {
            this.toastr.warning('Please enter at least one choice for the english language.', 'ELI');
            return;
        }

        //let negativelyKeyed = 0;
        //if (this.negativelyKeyed) {
        //    negativelyKeyed = 1;
        //}

        let questionDto = new QuestionDto();
        questionDto.Id = questionId;
        questionDto.Type = this.type;
        //questionDto.Levels = parseInt($('#levels').val().toString());
        //questionDto.NegativelyKeyed = negativelyKeyed;
        questionDto.IsTestQuestion = testQuestion;
        questionDto.Localizations = this.localizations;
        questionDto.Choices = choices;
        questionDto.IsMandatory = this.isMandatory;

        this.savingQuestion = true;

        this._AdminService.postSaveQuestion(questionDto).subscribe(data => {
            console.log('postSaveQuestion response', data);
            this.savingQuestion = false;
            if (data.result.Result != 0) {
                this.toastr.success('Edited successfully.', 'ELI');
                if (this._Globals.boolGetAllQuestions) {
                    this.parent.getAllQuestions();
                } else {
                    this.parent.updateRowEntry(this.parent.surveyGridApi, this.parent.currentRowIndex, this.localizations[0].Text, this.testQuestion);
                } 
                this.close();
            }
            else {
                this.toastr.error('Error. Please try again.', 'ELI');
            }
        });


        //this.questionEmpty(text);
        //this.parent.insertNewRow(text);
        //this.modalSave.emit();
    }

    generateJson(): string[] {
        //localizations
        this.localizations;
        let jsonArray = [];
        //let choicesGroupById = [];
        let allChoices = [];

        let content = [];
        let groupOfChoices = [];
        let choice = {};
        let currentId;
        let hasId = false;
        for (var i = 0; i < this.languages.length; i++){

            let shortcode = this.getShortcodeByIndex(i);
            

            for (var j = 0; j < this.choicesDictionary[shortcode].length; j++){
                allChoices.push(this.choicesDictionary[shortcode][j]);
            }
        }
        console.log('allChoices', allChoices);

        //choices
        let allIds = this.getAllIdsFromGroup(allChoices);
        let choicesGroupById = this.groupById(allChoices);
        let choicef = this.setJsonFormat(choicesGroupById);

        //deleted choices
        this.getAllIdsFromGroup(this.deletedChoices);
        let choicesDeletedGroupById = this.groupById(this.deletedChoices);
        let deletedf = this.setJsonFormat(choicesDeletedGroupById);
    
        jsonArray = choicef.concat(deletedf);

        console.log('finalChoices', choicef);

        let res = JSON.stringify(jsonArray);
        console.log('choicef encode: ' + res);

        return jsonArray;
    }

    //getting all ids from a choices group
    getAllIdsFromGroup(allChoices: any[]):any[] {
        //let allIds = [];
        this.allIds = [];

        //geting all ids
        for (var i = 0; i < allChoices.length; i++) {
            let id = allChoices[i].Id;
            if (this.allIds.indexOf(id) == -1) {
                this.allIds.push(id);
            }
        }

        console.log('allIds', this.allIds);
        return this.allIds;
    }
    //group all ids by id
    groupById(allChoices:any[]):any[] {
        //grouping by id
        let choicesGroupById = [];

        for (var i = 0; i < this.allIds.length; i++) {
            let currentId = this.allIds[i];
            let groupChoices = [];
            for (var j = 0; j < allChoices.length; j++) {
                if (allChoices[j].Id == currentId) {
                    if (currentId == 0) {
                        allChoices[j].Status = 0;
                    }
                    groupChoices.push(allChoices[j]);
                }
            }
            //separate in a new array the questions with the id 0
            if (groupChoices[0].Id == 0) {
                let arraytoSplit = groupChoices;
                for (var j = 0; j < arraytoSplit.length; j++) {
                    groupChoices = [];
                    groupChoices.push(arraytoSplit[j]);
                    choicesGroupById.push(groupChoices);
                }
            } else {
                choicesGroupById.push(groupChoices);
            }
            
        }

        console.log('globalArray', choicesGroupById);
        return choicesGroupById;
    }

    //setting our format service
    setJsonFormat(choicesgroup: any[]):any[] {
        let finalChoices = [];
        let choicef = [];
        let localizationsGroup = [];

        for (var i = 0; i < choicesgroup.length; i++) {
            localizationsGroup = [];

            for (var n = 0; n < choicesgroup[i].length; n++) {
                let localizationsProp = {
                    "LanguageShortCode": choicesgroup[i][n].LanguageShortCode,
                    "Text": choicesgroup[i][n].Text
                }
                localizationsGroup.push(localizationsProp);
            }

            let choiceProp = {
                "Id": choicesgroup[i][0].Id,
                "Status": choicesgroup[i][0].Status,
                "Order": i,
                "Localizations": localizationsGroup
            }
            choicef.push(choiceProp);
        }

        console.log('finalChoices', choicef);

        return choicef;

    }



    questionEmpty(text) {
        if (text == "") {
            $('#surveyTextarea').addClass('empty');
            setTimeout(function () {
                $('#surveyTextarea').removeClass('empty');
            }, 500);
            return;
        }
    }

    addLocalization(text: string, languageShortCode: string) {
        //if (text != '') {
            console.log('setLocalization');
            if (this.localizations.length == 0) {
                this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
            }
            else {

                let arrayLength = this.localizations.length;
                let addNew = true;
                for (var i = 0; i < arrayLength; i++) {
                    if (this.localizations[i].LanguageShortCode == languageShortCode) {
                        //property exist
                        addNew = false;
                        this.localizations[i].Text = text;
                    }
                }
                if (addNew) {
                    //property not exist
                    this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
                }
            }
            console.log(this.localizations);
        //}
    }

    clearTextArea() {
        $('#surveyTextarea').val('');
    }

    checkData(languageShortCode: string, event: any) {
        let language = event.target.selectedOptions["0"].id;

        this.currentOrDefaultLanguageShortCode = languageShortCode;
        this.currentOrDefaultLanguage = language;

        console.log('event', event);
        this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let arrayLength = this.localizations.length;
        for (var i = 0; i < arrayLength; i++) {
            if (languageShortCode == this.localizations[i].LanguageShortCode) {
                //property exist
                let text = this.localizations[i].Text;
                $('#surveyTextarea').val(text);
            }
        }

        this.setCurrentLocalizationsChoices(this.choices, languageShortCode);
    }
    
    preventSpace(value: string, event: any, tag: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $("#" + tag + "").val('');
        }
    }

    moveUp(index, arrayName) {
        if (index > 0) {
            const tmp = arrayName[index - 1];
            arrayName[index - 1] = arrayName[index];
            arrayName[index] = tmp;
        }
    }

    moveDown(index, arrayName) {
        if (index + 1 == arrayName.length) {
            return;
        }
        if (index < arrayName.length) {
            const tmp = arrayName[index + 1];
            arrayName[index + 1] = arrayName[index];
            arrayName[index] = tmp;
        }
    }


    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        let hiddenHeader = {
            headerName: '',
            field: '',
            sort: 'asc',
            minWidth: 20,
            width: 20,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            hide: true,
            cellRenderer: function (params) {
                return '';
            }
        };
        columnDefs.push(hiddenHeader);

        console.log('header');
        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            minWidth: 200,
            width: 200,
            hide: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    minWidth: 85,
        //    width:85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';
 
        //        content += '<i id="editAction" class="material-icons custom-icons">edit</i>';
 
        //        content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';
 
        //        //content += '<i id="bulkUpload" class="material-icons custom-icons">file_upload</i>';
 
        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';
 
        //    }
        // };
        // columnDefs.push(actionsHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 200,
            width: 200,
            hide: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(statusHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            this.edit('edit', data['Id'], data['Text']);
            this.currentRowIndex = e.rowIndex;


            //// this.currentIndex = e.rowIndex;
            //switch (e.event.target.id) {
            //   case "editAction":
            //       {
            //           //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //           this.edit('edit', data['Id'], data['Text']);
            //           break;
            //       }

            //   case "deleteAction":
            //       {
            //           //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //           this.confirmDelete();
            //           break;
            //       }
            //}
        }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    changeTestQuestionStatus() {
        this.testQuestion = !this.testQuestion;
        console.log(this.testQuestion);
    }


    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            let text = selected[0].Text;
            console.log("SELECTED ID", id);

            this.edit('edit', id, text);
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            let selected = this.getSelectedRows();
            let id = selected[0].Id;
            console.log("SELECTED ID", id);

            this.confirmDelete();
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    confirmDelete() {
        swal({
            title: 'Confirm Delete',
            text: "Are you sure you want to delete this choice?",
            showCancelButton: true,
            focusConfirm: false,
            allowEnterKey: false,
            cancelButtonColor: '#888',
            confirmButtonColor: '#3472F7',
            confirmButtonText: 'Yes'
        }).then((result: any) => {
            if (result.value) {
                this.delete();
            }
        });
    }

    edit(action:string, id: number, text: string) {
        console.log('edit');
        $('#createchoiceTextarea').val(text);

        this.openChoiceModal(action);
        //this.openModal('edit', id, text);
    }

    updateChoice(text: string) {

        //console.log(this.currentLocalizationsChoices);
        var model = this.gridApi.getModel();
        var rowNode = model.rowsToDisplay[this.currentRowIndex];
        rowNode.setDataValue("Text", text);

        this.closeChoiceModal();
        console.log('choicesDictionary', this.choicesDictionary);
    } 

    delete() {
        this.populateLocalizations();

        var model = this.gridApi.getModel();
        var rowNode = model.rowsToDisplay[this.currentRowIndex];
        rowNode.setDataValue("Status", 2);

        //let rowNode = this.gridApi.getRowNode();
        let index = rowNode.rowIndex;
        model.rowsToDisplay.splice(index, 1);

        let nodeDeleted = this.choicesDictionary[rowNode.data.LanguageShortCode][index];
        if (rowNode.data.Id != 0){
            this.deletedChoices.push(nodeDeleted);
        }

        this.choicesDictionary[rowNode.data.LanguageShortCode].splice(index, 1);
        let currentId = rowNode.data.Id;
        this.deleteDeletedChoices(currentId, rowNode.data.LanguageShortCode);
        let nodeToDelete = [rowNode.data];
        

        //var res = this.gridOptions.api.updateRowData({ remove: nodeToDelete });

        //this.currentLocalizationsChoices = this.choicesDictionary[rowNode.data.LanguageShortCode];

        //var res = this.gridApi.updateRowData({ remove: [rowNode.data] });

        //this.choicesDictionary[rowNode.data.LanguageShortCode].splice(index, 1);

        //console.log('choicesDictionary', this.choicesDictionary);

        this.closeChoiceModal();
        this.currentLocalizationsChoices = [];

        setTimeout(() => {
            this.currentLocalizationsChoices = this.choicesDictionary[rowNode.data.LanguageShortCode];
            this.gridApi.redrawRows();
            this.sizeToFit();
        }, 1);

        this.deselectAllCheckBox();
        console.log('choicesDictionary', this.choicesDictionary);
        
    }

    deleteDeletedChoices(id: number, excludedShortCode:string) {
        for (var i = 0; i < this.localizations.length; i++){
            let currentShortcode = this.getShortcodeByIndex(i);
            for (var j = 0; j < this.choicesDictionary[currentShortcode].length; j++) {

                if (currentShortcode != excludedShortCode){
                    if (id == this.choicesDictionary[currentShortcode][j].Id) {
                        let nodeDeleted = this.choicesDictionary[currentShortcode][j];
                        this.choicesDictionary[currentShortcode][j].Status = 2;

                        //excluding new choices with the id 0
                        if (this.choicesDictionary[currentShortcode][j].Id != 0) {
                            this.deletedChoices.push(nodeDeleted);
                        }

                        this.choicesDictionary[currentShortcode].splice(j, 1);
                        
                    }
                }
            }
        }
        console.log('deletedChoices',this.deletedChoices);
    }

    openChoiceModal(action: string) {
        switch (action) {
            case 'new': {
                this.choiceAction = "Create";
                this.newChoice = true;
                break;
            }
            case 'edit': {
                this.choiceAction = "Edit";
                this.editChoice = true;
                break;
            }
                
        }
        $("#modal").modal({ backdrop: "static" });
        $('#modal').modal('show');
    }
     
    closeChoiceModal() {
        $('#modal').modal('hide');
        this.newChoice = false;
        this.editChoice = false;
        $('#createchoiceTextarea').val('');
        console.log('currentLocalizationsChoices', this.currentLocalizationsChoices);
    }

    addNewChoice(language: string, shortcode: string, text: string) {
        let newChoice = {
            "LanguageName": language,
            "LanguageShortCode": shortcode,
            "Text": text,
            "Id": 0
        };
        this.choicesDictionary[shortcode].push(newChoice);
        var res = this.gridApi.updateRowData({ add: [newChoice] });

        console.log('choicesDictionary',this.choicesDictionary);
        $('#modal').modal('hide');
        $('#createchoiceTextarea').val('');
        this.closeChoiceModal();
        this.populateLocalizations();
        setTimeout(() => {
            this.sizeToFit();
        }, 10);
    } 
   
}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
